module.exports = __webpack_public_path__ + "img/storekeeper.3f849ca3.png";